import React from "react";

export default function HeroComex({
  titulo,
  subtitulo,
  imagen,
  video,
  height = "h-[460px]",
  titleClassName = "text-sidom-light text-2xl md:text-4xl lg:text-5xl font-extrabold text-center mb-5 drop-shadow-lg",
}) {
  const urlApi = process.env.REACT_APP_STRAPI_URL;

  return (
    <section
      className={`relative w-full ${height} flex items-center justify-center overflow-hidden`}
    >
      <div className="">
        {video ? (
          <video
            className="absolute top-0 left-0 w-full h-full object-cover z-0"
            autoPlay
            playsInline
            loop
            muted
          >
            <source src={`${urlApi}${video}`} type="video/mp4" />
          </video>
        ) : (
          <img
            src={`${urlApi}${imagen}`}
            alt="Puerto y autos Comex"
            className="absolute top-0 left-0 w-full h-screen object-cover z-0"
            draggable={false}
          />
        )}

        <div className="container line-clamp-1 z-20 w-full flex flex-col items-center justify-center px-2">
          <h1 className={titleClassName}>
            {titulo}
          </h1>
          <p className="text-sidom-light text-base md:text-lg lg:text-xl text-center max-w-4xl mx-auto drop-shadow">
            {subtitulo}
          </p>
        </div>
      </div>
    </section>
  );
}
